/*@ngInject*/
const SpacerController = function($scope, $rootScope, $controller, xmlUtil, formViewerConstant) {

    angular.extend(this, $controller('baseFormComponentController', {$scope: $scope}));

    this.$onInit = function() {
        this.onInit();

        let options = xmlUtil.parseString(this.fieldStructure.uiField.options);
        this.spacerWidth = options.width;
        this.spacerHeight = options.height;
        this.isConfigurableComponent = this.fieldStructure.isConfigurableComponent === true;
        this.configurationClass = this.isConfigurableComponent ? 'configurable' : '';

        if(this.fieldStructure.isConfigurableComponent) {
            this.spacerWidth = parseInt(options.width) < 18 ? 18 : options.width;
        }


    };

    this.handleClick = function() {
        $rootScope.$broadcast(formViewerConstant.event.FOCUSED_FIELD_CHANGED, this.fieldStructure);
    };

};

angular.module('umFormViewer')
    .controller('spacerController', SpacerController);
